import type { RouteObject } from "react-router-dom";
import { BrowseListingView } from "./components/BrowseListing/browseListingView";
import { ExploreListingView } from "./components/exploreListingView/exploreListingView";
import { ComparePropertiesView } from "./components/ComparePropertiesView/comparePropertiesView";
import { CompareMarketAnalysisView } from "./components/CompareMarketAnalysisView/compareMarketAnalysisView";

export const routes = (): RouteObject[] => {
  return [
    {
      path: "*",
      element: <ExploreListingView />,
    },
    {
      path: "/compare",
      element: <ComparePropertiesView />,
    },
    {
      path: "/listings/:listingId",
      element: <BrowseListingView />,
    },
    {
      path: "/listings/:zlid/cma",
      element: <CompareMarketAnalysisView />,
    },
  ];
};
